export module ActionTypes {
    export const GET_NOTES: string = "GET_NOTES";
    export const CREATE_NEW_NOTES: string = "CREATE_NEW_NOTES";
    export const REMOVE_NOTES: string = "REMOVE_NOTES";
    export const NOTES_SUCCESS: string = "NOTES_SUCCESS";
    export const REG_REQUEST: string = "REG_REQUEST";
}
